/**
 * `ehFalaDoCartaoDeOnboarding(texto)` — esta fala veio de um BOTÃO do cartão de
 * onboarding? Espelho de `core/onboarding/falas.e_resposta_do_cartao` (backend).
 *
 * ★ **Por que o front precisa da MESMA régua.** Desde 21/09/2026 o servidor só
 * avança a apresentação com a resposta do cartão (fala livre vai ao modelo). O
 * front usa a régua para a porta: a fala do cartão vai SEMPRE por `/chat` —
 * o `POST /runs` do Modo Agente não conhece o onboarding —, mesmo depois de a
 * pessoa ter clicado em "Continuar sem a apresentação" (que só destrava o
 * composer). Sem isto, com `IA - Agente` ligada, o "Continuar" clicado depois
 * da dispensa saía como texto livre para o worker.
 *
 * As quatro formas, e só elas: "Continuar", "Pular esta etapa" (caixa, acento e
 * espaço nas pontas não contam — quem DIGITA "continuar" também está pedindo
 * para seguir), as respostas do formulário da etapa 1 (pelo prefixo) e a lista
 * de prioridades da etapa 2 (pelo prefixo). Os prefixos são comparados como
 * estão: quem os monta é o front, byte a byte.
 *
 * Mora aqui, e não em `chave-do-onboarding.js`, porque aquele arquivo é FOLHA
 * (zero imports) e este precisa do prefixo das prioridades.
 */
import {
  FALA_DO_CONTINUAR,
  FALA_DO_PULAR,
  PREFIXO_RESPOSTAS_DO_ONBOARDING,
} from '@modules/aawz-intelligence-v2/ui-registry/chave-do-onboarding'
import { PREFIXO_DA_FALA } from '@modules/aawz-intelligence-v2/utils/prioridades-do-dia-a-dia'

// A MESMA normalização de `core/onboarding/comando._normalizar`: minúsculas,
// sem acento, sem espaço nas pontas.
function normalizar(texto) {
  return texto
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase()
}

const FALAS_EXATAS = [FALA_DO_CONTINUAR, FALA_DO_PULAR].map(normalizar)
const PULAR_NORMALIZADO = normalizar(FALA_DO_PULAR)

/**
 * A fala é o "Pular esta etapa" do cartão? Mesma normalização do backend —
 * é com ela que o cartão diz "etapa pulada" em vez de mostrar respostas
 * vazias ([owner, 21/09/2026]).
 *
 * @param {*} texto a fala do turno.
 * @returns {boolean}
 * @example ehFalaDoPular('pular esta etapa') // → true
 */
export function ehFalaDoPular(texto) {
  if (typeof texto !== 'string') return false
  return normalizar(texto) === PULAR_NORMALIZADO
}

/**
 * @param {*} texto a fala do turno.
 * @returns {boolean}
 * @example ehFalaDoCartaoDeOnboarding('Pular esta etapa') // → true
 */
export function ehFalaDoCartaoDeOnboarding(texto) {
  if (typeof texto !== 'string') return false
  const conteudo = texto.trim()
  if (!conteudo) return false
  if (FALAS_EXATAS.indexOf(normalizar(conteudo)) !== -1) return true
  if (conteudo.indexOf(PREFIXO_RESPOSTAS_DO_ONBOARDING) === 0) return true
  return conteudo.indexOf(PREFIXO_DA_FALA) === 0
}
